import { create } from 'zustand';
import {
  addToEditorData,
  DEFAULT_EDITOR_DATA,
} from '@quicktools/shared-components/components/domainSpecific/text/Editor';
import { FontData } from '@quicktools/shared-components/types/text';
import { NO_FONT } from '@quicktools/shared-components/utils/fonts';

export interface ISymbolState {
  editorData: FontData;
  showModal: boolean;
  searchTerm: string;
  editorExpanded: boolean;
  canShowCopyTooltip: boolean;
  setSearchTerm: (value: string) => void;
  addToEditor: (text: string) => void;
  setEditorData: (editorData: FontData) => void;
  toggleModal: () => void;
  disableHoverTooltip: () => void;
  setEditorExpanded: (expanded: boolean) => void;
}

const defaultCopyList = '';

const useStore = create<ISymbolState>()((set, get) => ({
  showModal: false,
  searchTerm: '',
  editorExpanded: false,
  canShowCopyTooltip: true,
  copyList: defaultCopyList,
  editorData: DEFAULT_EDITOR_DATA,

  toggleModal: () => {
    const { showModal } = get();

    set({
      showModal: !showModal,
    });
  },

  setSearchTerm: (searchTerm: string) => {
    set({
      searchTerm,
    });
  },

  disableHoverTooltip: () => {
    const { canShowCopyTooltip } = get();

    set({
      canShowCopyTooltip: !canShowCopyTooltip,
    });
  },

  setEditorExpanded: (editorExpanded) => {
    set({
      editorExpanded,
    });
  },

  setEditorData: (editorData) =>
    set({
      editorData,
    }),

  addToEditor: (text: string) => {
    const { editorData } = get();

    set({
      editorData: addToEditorData(editorData, text, NO_FONT),
    });
  },
}));

export default useStore;
